<template>
  <label for="input-with-action" class="input-with-action-wrapper">
    <div class="input-icon icon-14px icon-gray">
      <slot name="icon">
        <PlusIcon />
      </slot>
    </div>
    <div class="input-wrapper mr-11">
      <input
        id="input-with-action"
        ref="input"
        v-model="inputValue"
        autocomplete="off"
        class="input-with-action"
        type="text"
        :placeholder="placeholder"
        @focus="changeFocusStatus(true)"
        @blur="changeFocusStatus(false)"
        @keypress="updateWidth"
        @input="$emit('change', $event.target.value)"
      />
    </div>
    <button
      v-if="withClear"
      :title="t('Clear')"
      type="button"
      class="clear-button"
      @click="$emit('clear')"
    >
      <CircleIcon width="16" />
    </button>
    <v-tooltip v-if="localError" bottom max-width="345" transition="scroll-y-transition">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" class="flex-centering spacex-4 pointer mr-11" v-on="on">
          <InfoIcon class="icon-d-600 icon-16px" />
          <span class="danger-600 text-sm">{{ $t('An error occurred') }}</span>
        </div>
      </template>
      <div>
        {{ $t(localError) }}
      </div>
    </v-tooltip>
    <Button
      v-if="buttonText"
      class="input-btn"
      size="small"
      :disabled="!inputValue"
      @click="submitHandler"
    >
      <Spinner v-if="isLoading" size="20" />
      <span v-else class="no-wrap">{{ buttonText }}</span>
    </Button>
  </label>
</template>

<script>
  import PlusIcon from '@/assets/icons/plus.svg';
  import Button from '@/components/ui/Button';
  import Spinner from 'vue-simple-spinner';
  import InfoIcon from '@/assets/icons/info-filled.svg';
  import { VTooltip } from 'vuetify/lib';
  import CircleIcon from '@/assets/icons/circle-x.svg';
  import t from '@/i18n';

  export default {
    name: 'InputWithAction',
    components: {
      Button,
      PlusIcon,
      Spinner,
      InfoIcon,
      VTooltip,
      CircleIcon,
    },
    model: {
      prop: 'initialValue',
      event: 'change',
    },
    props: {
      initialValue: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      buttonText: {
        type: String,
        default: '',
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      error: {
        type: String,
        default: null,
      },
      // Если запрос сверху прошел успешно, то можно поменять
      // этот свитчер у родителя и выполнить желаемое действие в компоненте
      clearFieldTrigger: {
        type: Boolean,
        default: false,
      },
      withClear: Boolean,
    },
    data() {
      return {
        inputFocused: false,
        inputValue: this.initialValue,
        localError: null,
      };
    },
    watch: {
      clearFieldTrigger() {
        this.inputValue = '';
      },
      error(val) {
        this.localError = val;
      },
      inputValue() {
        this.localError = null;
      },
    },
    methods: {
      t,
      submitHandler() {
        this.$emit('submit', this.inputValue);
      },
      changeFocusStatus(value) {
        this.inputFocused = value;
        this.$emit(value ? 'focus' : 'blur');
      },
      updateWidth() {
        this.$refs.input.style.width = (this.inputValue.length + 1) * 9 + 'px';
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/colors';

  .input-with-action-wrapper {
    padding: 12px;
    border: 1px solid $grey200;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: text;

    .input-icon {
      margin-right: 8px;
    }

    .input-btn {
      margin: -5px -5px -5px 4px;
    }

    .input-wrapper {
      flex: 1;
      display: flex;
      overflow: hidden;
      .input-with-action {
        flex: 1;
        width: fit-content;
        border-radius: 0;
        font-weight: 500;
        &::placeholder {
          color: $text-tertiary;
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 140%;
        }
        &:focus {
          width: 200px;
        }
        &:focus::placeholder {
          color: transparent;
        }
      }
    }
  }

  .clear-button {
    height: 16px;
    margin-right: 6px;

    svg {
      width: 16px;
      height: 16px;
    }
  }
</style>
